<div class="flexie-auto-grid m-t-b-60">

    <div class="flex-self-vert-start">
      <div *ngIf="!savedAdd">
        <div class="zero-ui">
          <i nz-icon nzType="schedule" nzTheme="outline"></i>
          <h2>Add Coverage</h2>
          <p>You'll see coverages here once you add</p>
        </div>
      </div>
      <div *ngIf="savedAdd">
        <h3>Coverage Details </h3>
        <nz-list [nzDataSource]="list" [nzItemLayout]="'horizontal'" [nzRenderItem]="item">
          <ng-template #item let-item>
            <nz-list-item [nzActions]="[editAction,moreAction]">
              <nz-skeleton [nzActive]="true" [nzLoading]="false">
                <ng-template #moreAction><a (click)="edit(item)">select as Preffered</a></ng-template>
                <ng-template #editAction><a (click)="edit(item)">edit</a></ng-template>
                <ng-template #moreAction><a (click)="view(item)">delete</a></ng-template>
                <nz-list-item-meta [nzTitle]="'PAP'" nzDescription="INR 23,45,656.00">
                </nz-list-item-meta>
              </nz-skeleton>
            </nz-list-item>
          </ng-template>
        </nz-list>
      </div>
    </div>
  
    <div class="adjust-blocks">
      <div class="form-secondary">
  
        <h3 class="form-secondary-heading">+ Add Coverage</h3>
  
        <div class="form-secondary-fields p-l-r-20 p-t-b-10">
          
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Coverage Type</nz-form-label>
            <nz-form-control [nzSpan]="24">
                <nz-select nzShowSearch  style="width: 220px;" nzAllowClear nzPlaceHolder="Choose">
                  <nz-option nzValue="1" nzLabel="Flood"></nz-option>
                  <nz-option nzValue="0" nzLabel="PAP"></nz-option>
                </nz-select>
              </nz-form-control>
          </nz-form-item>
  
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Sum Insured</nz-form-label>
            <nz-form-control [nzSpan]="24">
              <input nz-input placeholder="Sum Insured" [(ngModel)]="suminsured" name="input-basic" />
            </nz-form-control>
          </nz-form-item>
        </div>
  
        <div class="footer-actions-bar">
          <div>
            <!-- Left -->
          </div>
          <div>
            <!-- Right -->
            <button nz-button class="b-0 m-r-10">Clear</button>
            <button nz-button [nzType]="'primary'" (click)="savedAdd=!savedAdd">Add</button>
          </div>
        </div>
      </div>
    </div>
  
  </div>
  